import { render, staticRenderFns } from "./InstagramBusinessChannelGeographics.vue?vue&type=template&id=62092fec"
import script from "./InstagramBusinessChannelGeographics.vue?vue&type=script&lang=js"
export * from "./InstagramBusinessChannelGeographics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports